<!--
 * @Descripttion: 暂无数据
 * @Author: chenjinsheng
 * @Date: 2021-08-31 11:33:53
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-08-31 12:32:36
-->
<template>
    <div class="empty">
        <img src="@/assets/pics/no-empty.png" />
        <span><slot>暂无数据</slot></span>
    </div>
</template>

<script>
export default {
    name: "NoEmpty",
};
</script>

<style lang="scss" scoped>
.empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
        padding: 10px 0;
        color: #999999 !important;
    }
}
</style>
